interface PerkValidityProps {
  startedAt: string | null;
  endedAt: string | null;
  quota: number | null;
  totalRedeemed: number;
  isUpcoming?: boolean;
}

export const PerkValidity = ({
  startedAt,
  endedAt,
  quota,
  totalRedeemed,
  isUpcoming,
}: PerkValidityProps) => {
  const renderValidity = () => {
    if (isUpcoming) {
      return <span>Available from {startedAt}</span>;
    }

    if (!endedAt) {
      return <span>Unlock Anytime</span>;
    }

    return <span>Unlockable till {endedAt}</span>;
  };

  return (
    <div className="tw-flex tw-items-center tw-justify-center">
      <span className="tw-text-[1.375rem] tw-text-[#777] tw-leading-normal">
        {renderValidity()}
        {quota && (
          <span className="tw-ml-1">
            |{' '}
            <span className="tw-font-semibold">
              {quota - totalRedeemed} of {quota} Left
            </span>
          </span>
        )}
      </span>
    </div>
  );
};
